import { render, staticRenderFns } from "./TicketAbout.vue?vue&type=template&id=0c830fb6&"
import script from "./TicketAbout.vue?vue&type=script&lang=ts&"
export * from "./TicketAbout.vue?vue&type=script&lang=ts&"
import style0 from "@/style/components/tickets/ticket.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports